import { fork } from 'redux-saga/effects';

import {
    initialDataFetch,
    watchSetLoggedIn,
    watchLogout,
} from './environment';

import {
    watchCancelBooking,
    watchCheckOutBooking,
    watchCheckInBooking,
    watchUpdateBookingTimes,
    watchFetchUnavailableTimes,
    watchClickEditBookingTime,
} from './booking';

import {
    watchFetchAvailablePlantTypes,
    watchFetchAvailablePlant,
    watchCreateBooking,
} from './createBooking';

// Export generator functions that are executed as soon as the store is ready
export default function* root() {
    yield [
        fork(initialDataFetch),
        fork(watchSetLoggedIn),
        fork(watchLogout),
        fork(watchCancelBooking),
        fork(watchCheckOutBooking),
        fork(watchCheckInBooking),
        fork(watchUpdateBookingTimes),
        fork(watchFetchUnavailableTimes),
        fork(watchFetchAvailablePlantTypes),
        fork(watchClickEditBookingTime),
        fork(watchFetchAvailablePlant),
        fork(watchCreateBooking),
    ];
}



// WEBPACK FOOTER //
// ./scripts/sagas/index.js